import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DocumentVersionHistory = ({ versions, onVersionRestore, onVersionCompare }) => {
  return (
    <div className="bg-card rounded-lg border border-border overflow-hidden">
      <div className="flex items-center justify-between p-4 border-b border-border bg-muted/30">
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg">
            <Icon name="History" size={20} color="var(--color-primary)" />
          </div>
          <div>
            <h3 className="text-sm md:text-base font-semibold text-foreground">Version History</h3>
            <p className="text-xs text-muted-foreground">{versions?.length} saved version{versions?.length !== 1 ? 's' : ''}</p>
          </div>
        </div>
        <Button variant="outline" size="sm" iconName="GitCompare" iconPosition="left">
          Compare
        </Button>
      </div>
      <div className="max-h-96 overflow-y-auto">
        {versions?.map((version, idx) => (
          <div
            key={version?.id}
            className={`p-4 border-b border-border hover:bg-muted/50 transition-smooth ${
              idx === 0 ? 'bg-primary/5' : ''
            }`}
          >
            <div className="flex items-start justify-between gap-3">
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-2">
                  <p className="text-sm font-semibold text-foreground">{version?.title}</p>
                  {idx === 0 && (
                    <span className="text-xs px-2 py-1 bg-primary text-primary-foreground rounded">Current</span>
                  )}
                </div>
                <div className="flex flex-wrap items-center gap-3 text-xs text-muted-foreground mb-2">
                  <div className="flex items-center gap-1">
                    <Icon name="User" size={14} />
                    <span>{version?.author}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <Icon name="Clock" size={14} />
                    <span>{version?.timestamp}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <Icon name="FileText" size={14} />
                    <span>{version?.wordCount} words</span>
                  </div>
                </div>
                {version?.changesSummary && (
                  <p className="text-xs text-muted-foreground line-clamp-2">{version?.changesSummary}</p>
                )}
              </div>
              <div className="flex flex-col gap-2 flex-shrink-0">
                <Button
                  variant="outline"
                  size="xs"
                  iconName="Eye"
                  iconPosition="left"
                  onClick={() => console.log('View version:', version?.id)}
                >
                  View
                </Button>
                {idx !== 0 && (
                  <Button
                    variant="outline"
                    size="xs"
                    iconName="RotateCcw"
                    iconPosition="left"
                    onClick={() => onVersionRestore(version?.id)}
                  >
                    Restore
                  </Button>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DocumentVersionHistory;